<template>
  <v-container fluid>
    <v-row class="mb-7" align="center" justify="center">
      <!--h1>{{ vendor.name }}</h1!-->
      <v-img :src="vendor.logoUrl" max-height="37" contain position="center center"/>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="3">
        <h4 class="special-border py-3">{{ $t('table.items.TARGET') }}</h4>
        <h4 class="special-border py-3">{{ $t('table.items.COST') }}</h4>
        <h4 :class="`${(i < vendorEvaluations[0].rules.length - 1)? 'special-border py-3' : 'py-3' }`" v-bind:key="i" v-for="(rule, i) in vendorEvaluations[0].rules">
          {{ $t(`table.items.${rule.fundingRuleType}`) }}
        </h4>
      </v-col>
      <v-col cols="3" v-bind:key="i" v-for="(fullEvaluation, i) in vendorEvaluations">
        <v-card :class="(selectedEvaluation !== null && selectedEvaluation.id === fullEvaluation.evaluation.id)? 'selected-evaluation-card px-2 py-3' : 'evaluation-card px-2 py-3'" outlined >
          <h1 class="text-center">{{ formatBalance(fullEvaluation.evaluation.initialBalance) }}</h1>
          <h4 class="text-center special-border py-3">${{ fullEvaluation.evaluation.target - fullEvaluation.evaluation.initialBalance }}</h4>
          <h4 class="text-center special-border py-3">${{ fullEvaluation.evaluation.periodCost }}</h4>
          <h4 :class="(i < fullEvaluation.rules.length - 1)? 'special-border py-3 text-center' : 'py-3 text-center'"
               v-bind:key="i" v-for="(rule, i) in fullEvaluation.rules">
          {{ $t(`table.values.${rule.fundingRuleType}`, { value: (String(rule.fundingRuleType).endsWith('PERCENTAGE'))? Math.abs(rule.value * 100) : Math.abs(rule.value) }) }}
          </h4>
          <v-btn style="width: 100%" :class="(selectedEvaluation !== null && selectedEvaluation.id === fullEvaluation.evaluation.id)? 'btn-selected' : 'btn-not-selected'" elevation="0"
                 @click="selectEvaluation(fullEvaluation)">{{ $t((selectedEvaluation !== null && selectedEvaluation.id === fullEvaluation.evaluation.id)? 'btnSelected' : 'btnNotSelected') }}</v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "VendorEvaluationsTable",
  props: {
    vendor: Object,
    vendorEvaluations: Array,
  },
  data() {
    return {
      selectedEvaluation: null,
    }
  },
  methods: {
    selectEvaluation(fullEvaluation) {
      this.selectedEvaluation = fullEvaluation.evaluation;
      this.$emit('evaluationSelection', this.selectedEvaluation);
    },
    formatBalance(balance) {
      return (balance >= 1000000)? `$${balance/1000000}M` : `$${balance/1000}k`;
    }
  }
}
</script>



<style lang="scss" scoped>
@import "src/global";

.selected-evaluation-card {
  border: 2px solid $primary-color !important;
  border-radius: 15px !important;
}

.evaluation-card {
  border-radius: 15px !important;
}

.special-border {
  border-bottom: 1px solid $border-color !important;
}

.btn-selected {
  color: $black-color !important;
  background-color: $primary-color !important;
  border: 1px solid $border-color !important;
}

.btn-not-selected {
  color: $black-color !important;
  background-color: $white-color !important;
  border: 1px solid $border-color !important;
}
</style>
